// @flow
import React from 'react';
import SidebarContext from '../SidebarContext';
// eslint-disable-next-line import/named
import type { IntlShape } from 'react-intl';

import './SidebarButton.scss';

// Types
import { gtmUserEventType } from 'types/gtm';

type Props = {
  firstName: string,
  lastName: string,
  gtmUserEventSidebarButton: gtmUserEventType,
  intl: IntlShape
};

const SidebarButton = (props: Props) => {
  const ns = SidebarButton.block;
  const { firstName, lastName, gtmUserEventSidebarButton, intl } = props;

  return (
    <SidebarContext.Consumer>
      {({ toggleSidebar }) => {
        const openMenu = () => {
          gtmUserEventSidebarButton();
          toggleSidebar(true);
        };

        return (
          <span
            className={ns}
            onClick={() => openMenu()}
            onKeyUp={event => {
              if (event.key === 'Enter') {
                openMenu();
              }
            }}
            aria-label={intl.formatMessage({
              id: 'c8.aria.account.navigation.button',
              defaultMessage: 'Account navigation button'
            })}
            tabIndex={0}
          >
            {`${firstName.substring(0, 1)}${lastName.substring(0, 1)}`}
          </span>
        );
      }}
    </SidebarContext.Consumer>
  );
};

SidebarButton.block = 'sidebar-button';

export default SidebarButton;



// WEBPACK FOOTER //
// ./src/components/pages/User/Sidebar/SidebarButton/SidebarButton.js